export default function Circle() {
    return (
        <div className="Circle w-6 h-6 rounded-full border-[6px] border-primary shadow-[0_0_0_6px_rgba(0,138,255,0.1)]"></div>
    )
}
